import { useForm } from "react-hook-form";
import React from "react";
import emailjs from "emailjs-com";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import "./style.css";
import Layout from "../layout";
import { useState } from "react";

const Contact = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  // Function that displays a success toast on bottom right of the page when form submission is successful
  const toastifySuccess = () => {
    toast("Form sent!", {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      className: "submit-feedback Toastify__toast--success",
      toastId: "notifyToast",
    });
  };
  const [isblocked, setblock] = useState(false);
  const wait = () => {
    setblock(true);

    setTimeout(() => setblock(false), 5000);
  };

  // Function called on submit that uses emailjs to send email of valid contact form
  const onSubmit = async (data) => {
    // Destrcture data object
    const { name, email, subject, message } = data;
    try {
      const templateParams = {
        name,
        email,
        subject,
        message,
      };

      await emailjs.send(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_USER_ID
      );

      reset();
      toastifySuccess();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div className="fm">
      <div className="container max-w-screen-md w-full md:w-4/5 lg:w-3/5" bis_skin_checked="1">
          <h1 className="text-center sm:mb-5 font-normal mb-3 text-2xl sm:text-3xl uppercase">
            Contact Us
          </h1>
          <div className="ContactForm">
            <div className="container">
              <div className="row">
                <div className="col-12 text-center">
                  <div className="contactForm">
                    <form
                      id="contact-form"
                      onSubmit={handleSubmit(onSubmit)}
                      noValidate
                    >
                      {/* Row 1 of form */}
                      <div className="row formRow">
                        <div className="col-6">
                          <input
                            type="text"
                            name="name"
                            {...register("name", {
                              required: {
                                value: true,
                                message: "Please enter your name",
                              },
                              maxLength: {
                                value: 30,
                                message: "Please use 30 characters or less",
                              },
                            })}
                            className="form-control formInput"
                            placeholder="Name"
                          ></input>
                          {errors.name && (
                            <span className="errorMessage">
                              {errors.name.message}
                            </span>
                          )}
                        </div>
                        <div className="col-6">
                          <input
                            type="email"
                            name="email"
                            {...register("email", {
                              required: true,
                              pattern:
                                /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                            })}
                            className="form-control formInput"
                            placeholder="Email address"
                          ></input>
                          {errors.email && (
                            <span className="errorMessage">
                              Please enter a valid email address
                            </span>
                          )}
                        </div>
                      </div>
                      {/* Row 2 of form */}
                      <div className="row formRow">
                        <div className="col">
                          <input
                            type="text"
                            name="subject"
                            {...register("subject", {
                              required: {
                                value: true,
                                message: "Please enter a subject",
                              },
                              maxLength: {
                                value: 75,
                                message: "Subject cannot exceed 75 characters",
                              },
                            })}
                            className="form-control formInput"
                            placeholder="Subject"
                          ></input>
                          {errors.subject && (
                            <span className="errorMessage">
                              {errors.subject.message}
                            </span>
                          )}
                        </div>
                      </div>
                      {/* Row 3 of form */}
                      <div className="row formRow">
                        <div className="col">
                          <textarea
                            rows={3}
                            name="message"
                            {...register("message", {
                              required: true,
                            })}
                            className="form-control formInput"
                            placeholder="Message"
                          ></textarea>
                          {errors.message && (
                            <span className="errorMessage">
                              Please enter a message
                            </span>
                          )}
                        </div>
                      </div>
                      <button
                        className={
                          isblocked
                            ? "cursor-not-allowed pointer-events-none submit-btn"
                            : `submit-btn`
                        }
                        type="submit"
                        onClick={wait}
                      >
                        Submit
                      </button>
                    </form>
                  </div>
                  <ToastContainer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const ContactForm = () => {
  return <Layout children={<Contact />} />;
};
export default ContactForm;
